<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2023-11-16 15:35:49
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2024-03-25 17:03:59
 * @FilePath: \miniproweb\src\views\WarningCus\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="myBody">
    <div class="wraingTopBox">
      <div class="titleBox">
        <div class="titleText">预警信号订阅</div>
        <div class="saveBtn" @click="submitBtn">
          <van-icon name="star" />保存
        </div>
      </div>
      <div class="choosePlaceBox">
        <van-cell-group>
          <van-cell title="关注地区">
            <template #right-icon>
              <div @click="isSHowChoosePla=true">
                {{useChoosePale}}
                <van-icon name="arrow-down" />
              </div>
            </template>
          </van-cell>
          <van-cell title="订阅时间">
            <template #right-icon>
              <div @click="isSHowChooseTime=true">
                {{useChooseTime}}
                <van-icon name="arrow-down" />
              </div>
            </template>
          </van-cell>
          <van-cell title="订阅等级">
            <template #right-icon>
              <div @click="isShowleavelBox=true">
                {{chooseLeave}}
                <van-icon name="arrow-down" />
              </div>
            </template>
          </van-cell>
        </van-cell-group>
      </div>
    </div>
    <div class="chooseTypeBox">
      <div class="chooseTypeBoxTitle">
        <div>预警订阅</div>
        <div style="display:flex;  align-items: center;">
          <div class="myiconBox"></div>
          <div style="font-weight: 500;font-szie:12px;margin-left:5px">已选择</div>
        </div>
      </div>
      <div class="wertherTypeBox">
        <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">
          <div class="typeTitle">天气类型</div>
        </van-divider>
        <div class="wertherItemBox">
          <div class="wertherItem" v-for="item2  in waringList">
            <div class="chooseItemBox">
              <div class="weaiconBox">
                <img
                  :src="'https://moodsci.com/mimiproweb/img/'+item2.icon +'.png'"
                  style="width:30px;height:30px"
                  alt
                />
              </div>

              <div style="width:40px">{{item2.name}}</div>
              <div class="CheckBoxItem">
                <el-checkbox @change="chooseChange(item2.name)" :checked="checkList[item2.name]"></el-checkbox>
              </div>
            </div>
          </div>
          <!-- <div class=""></div> -->
          <!-- <div class="chooseItemBox" v-for="item2 in item.waring">
            <div class="weaiconBox">
              <van-icon name="like" color="#AAB6FF" size="30px" />
            </div>

            <div>
              {{item2}}
              <van-icon name="arrow-down" />
            </div>
          </div>-->
        </div>
      </div>
    </div>
    <div class="footerBox">以上数据由崇州市气象局提供，仅供公众参考</div>
    <div class="choosePopBox" v-show="isSHowChoosePla">
      <!-- <van-area
        title="标题"
        :area-list="areaList"
        @confirm="choosePla"
        @cancel="isSHowChoosePla=false"
      />-->
      <!-- <van-picker
        title="标题"
        show-toolbar
        :columns="areaList"
        @confirm="choosePla"
        @cancel="isSHowChoosePla=false"
      ></van-picker>-->
      <div class="areaChooseBox">
        <div class="areaChooseTopBox">
          <div style="font-size:12px" @click="isSHowChoosePla=false">取消</div>
          <div style="color:black">区域选择</div>
          <div style="font-size:12px" @click="choosePla">确认</div>
        </div>
        <div style=" height: 45vh;overflow: auto;">
          <van-checkbox-group v-model="areaCHooseList" shape="square">
            <van-checkbox
              :name="item"
              style="margin-top:10px"
              v-for="item in areaList"
            >{{item.text}}</van-checkbox>
          </van-checkbox-group>
          <div style="height:50px"></div>
        </div>
      </div>
    </div>
    <div class="choosePopBox" v-show="isSHowChooseTime">
      <van-picker
        title="时间选择"
        show-toolbar
        :columns="columns"
        @confirm="onConfirmTime"
        @cancel="isSHowChooseTime=false"
      />
    </div>
    <div class="choosePopBox" v-show="isShowleavelBox">
      <van-picker
        title="定制等级"
        show-toolbar
        :columns="leaverChooseList"
        @confirm="onConfirmLeave"
        @cancel="isShowleavelBox=false"
      />
    </div>
  </div>
</template>

<script>
// import axios from "axios";
import Vue from "vue";
import { Toast } from "vant";

Vue.use(Toast);
export default {
  data() {
    return {
      checkList: {},
      chooseLeave: "不定制",
      isShowleavelBox: false,
      columns: [
        { text: "白天(7:00-20:00)", data: 1 },
        { text: "全天", data: 0 }
      ],
      isSHowChoosePla: false,
      isSHowChooseTime: false,
      useChoosePale: "请选择",
      areaCHooseList: [],
      useChooseTime: "白天(7:00-20:00)",
      areaList: [
        {
          text: "白头镇",
          AreaCode: "510184112"
        },
        {
          text: "崇阳街道",
          AreaCode: "510184001"
        },
        {
          text: "大划街道",
          AreaCode: "510184116"
        },
        {
          text: "道明镇",
          AreaCode: "510184113"
        },
        {
          text: "观胜镇",
          AreaCode: "510184106"
        },
        {
          text: "怀远镇",
          AreaCode: "510184107"
        },
        {
          text: "江源街道",
          AreaCode: "510184102"
        },
        {
          text: "街子镇",
          AreaCode: "510184109"
        },
        {
          text: "廖家镇",
          AreaCode: "510184104"
        },
        {
          text: "隆兴镇",
          AreaCode: "510184114"
        },
        {
          text: "三江街道",
          AreaCode: "510184101"
        },
        {
          text: "文井江镇",
          AreaCode: "510184110"
        },
        {
          text: "羊马街道",
          AreaCode: "510184103"
        },
        {
          text: "元通镇",
          AreaCode: "510184105"
        },
        {
          text: "崇庆街道",

          AreaCode: "510184006"
        }
      ],
      leaverChooseList: [
        "接收全部",
        "黄色以上",
        "橙色以上",
        "仅红色",
        "不接收"
      ],
      waringList: [],
      choosePlaData: null,
      userChooseLeave: 1,
      timevalue: "1",
      myopenId: null
    };
  },
  created() {
    this.getWraingList();
    // console.log(this.$route.query);

    let myCode = this.getQueryString("code");
    // console.log(this.getQueryString("code"));
    if (myCode == null) {
      alert("授权失败");
    } else {
      // alert(myCode);
      this.getOpenId(myCode);
    }
  },
  methods: {
    chooseChange(e) {
      this.$set(this.checkList, e, false);
      console.log(this.checkList);
      // this.checkList[e] = false;
    },
    getImgurl(img) {
      console.log("../../assets/waringIcon/" + img + ".png");
      return require("../../assets/icon/" + img + ".png");
    },
    getQueryString(name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      let r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return decodeURIComponent(r[2]);
      }
      return null;
    },

    getOpenId(id) {
      this.$axios({
        url: `http://120.79.183.250:3093/InterfaceServices/WechatService/queryWechatOauth2Token?code=${id}` // 接口地址
      })
        .then(response => {
          // alert(id);
          // alert(response.data.data);
          console.log(JSON.parse(response.data.data));
          this.myopenId = JSON.parse(response.data.data).openid;
          console.log(this.myopenId);
          // alert(this.myopenId);
        })
        .catch(error => console.log(error, "error")); // 失败的返回
    },
    submitBtn(e) {
      // console.log(this.waringList);
      if (this.choosePlaData == null) {
        alert("请选择地区");
        return;
      }
      let contents = {};
      this.waringList.map(item => {
        // console.log(item);
        contents[item.name] = item.chooseL;
      });
      // console.log(contents);
      this.$axios({
        method: "post",
        url:
          "http://120.79.183.250:3093/InterfaceServices/WechatCustomWarningSignalService/updateWechatCustomWarningSignal", // 接口地址
        data: {
          areaCode: this.choosePlaData,
          contents: JSON.stringify(contents),
          id: "",
          remarks: "",
          subLevel: this.userChooseLeave,
          subTime: this.timevalue,
          updateDate: "",
          // wxOpenId: 1112
          wxOpenId: this.myopenId
        }
      })
        .then(response => {
          console.log(response);

          // console.log();
          // alert(JSON.stringify(response));
          if (response.data.code == 200) {
            alert("保存成功");
          } else {
            alert(response.data.message);
          }
        })
        .catch(error => console.log(error, "error")); // 失败的返回
    },
    getWraingList() {
      this.$axios({
        method: "",
        url:
          "http://120.79.183.250:3093/InterfaceServices/WarningService/queryWarnTypeList" // 接口地址
      })
        .then(response => {
          // console.log(response, "success"); // 成功的返回
          this.waringList = [];
          response.data.data.map(item => {
            // console.log(item);
            this.waringList.push({
              name: item.label,
              chooseL: 2,
              icon: item.icon
            });
            this.waringList.map(item => {
              this.checkList[item.name] = true;
            });
          });
          console.log(this.checkList);
        })
        .catch(error => console.log(error, "error")); // 失败的返回
    },
    onConfirmLeave(e) {
      console.log(e);
      this.isShowleavelBox = false;
      this.chooseLeave = e;
      if (e == "接收全部") {
        this.userChooseLeave = 1;
        this.waringList.map(item => {
          return (item.chooseL = 1);
        });
      } else if (e == "黄色以上") {
        this.userChooseLeave = 2;
        this.waringList.map(item => {
          return (item.chooseL = 2);
        });
      } else if (e == "橙色以上") {
        this.userChooseLeave = 3;
        this.waringList.map(item => {
          return (item.chooseL = 3);
        });
      } else if (e == "仅红色") {
        this.userChooseLeave = 4;
        this.waringList.map(item => {
          return (item.chooseL = 4);
        });
      } else if (e == "不接收") {
        this.userChooseLeave = -1;
        this.waringList.map(item => {
          return (item.chooseL = -1);
        });
      }
    },
    typeChooseHandell(e) {
      console.log(e.target.dataset.index);
      console.log(e.target.dataset.name);
      this.chooseLeave = "自定义";
      this.userChooseLeave = -1;
      let chooseindex = this.waringList.findIndex(item => {
        return item.name == e.target.dataset.name;
      });
      this.waringList[chooseindex].chooseL = Number(e.target.dataset.index);
      // this.$set(this.waringList, chooseindex, e.target.dataset.index);
      console.log(this.waringList);
    },
    onConfirmTime(e) {
      console.log(e);
      this.isSHowChooseTime = false;
      this.useChooseTime = e.text;
      this.timevalue = e.data;
    },
    choosePla() {
      this.isSHowChoosePla = false;
      let textList = [];
      let areaList = [];
      console.log(this.areaCHooseList);
      this.areaCHooseList.map(item => {
        textList.push(item.text);
        areaList.push(item.AreaCode);
      });
      this.choosePlaData = areaList.toString(",");
      this.useChoosePale = textList.toString(",");
    }
  }
};
</script>

<style>
* {
  box-sizing: border-box;
}
.myBody {
  height: 100%;
  width: 100%;

  /* padding: 0 10px; */
}
.wraingTopBox {
  height: 200px;
  width: 100%;
  background-color: #1a8fef;
  padding: 0 15px;
}
.titleBox {
  color: white;
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.titleText {
  color: white;
  font-size: 13px;
  font-weight: 500;
}
.saveBtn {
  height: 20px;
  width: 50px;
  border-radius: 10px;
  background-color: #1b8be0;
  border: 1px solid white;
  font-size: 12px;
  text-align: center;
}
.choosePlaceBox {
  /* height: 150px; */
  margin-top: 15px;
  width: 100%;
  background-color: aquamarine;
  border-radius: 5px;
  overflow: hidden;
}
.chooseTypeBox {
  /* height: 500px; */
  width: 100%;
  /* background-color: #1b8be0; */
  margin-top: 10px;
  border-radius: 15px;
  box-shadow: #93d7fe 0px 0px 8px 1px;
  background-color: white;
}
.chooseTypeBoxTitle {
  height: 40px;
  width: 100%;
  border-bottom: 1px solid rgb(219, 219, 219);
}
.myiconBox {
  height: 12px;
  width: 12px;
  border-radius: 50%;
  background-color: #f99366;
}
.chooseTypeBoxTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  font-size: 14px;
  font-weight: 600;
}
.typeTitle {
  height: 30px;
  width: 100px;
  /* background-color: #1a8fef; */
  position: relative;
  z-index: 1;
  color: white;
  line-height: 30px;
  text-align: center;
  font-weight: 600;
}
.typeTitle::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #42a8fd;
  transform: skewX(-25deg);
  z-index: -1;
}
.wertherItemBox {
  /* height: 60px; */
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0px 0px 20px 0px;
}
.wertherItem {
  display: flex;
  justify-content: center;
  width: 100px;
  margin-top: 15px;
  /* flex-wrap: wrap; */
}
.chooseItemBox {
  height: 100%;
  width: 20%;
  /* background-color: #1a8fef; */
  text-align: center;
  font-size: 12px;
}
.weaiconBox {
  height: 40px;
  width: 40px;
  margin: auto;
  border-radius: 50%;
  /* border: 1px solid #aab6ff; */
  display: flex;
  align-items: center;
  justify-content: center;
}
.footerBox {
  height: 50px;
  width: 100%;
  text-align: center;
  line-height: 50px;
  font-size: 12px;
}
.choosePopBox {
  position: fixed;
  bottom: 0;
  z-index: 99;
  left: 0;
  width: 100%;
}
.mychooseColorBox {
  height: 15px;
  width: 40px;
  /* background-color: #1a8fef; */
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin-top: 5px;
}
.colorBoxItem1 {
  background-color: red;
  width: 10px;
  height: 15px;
}
.colorBoxItem2 {
  background-color: rgb(255, 132, 0);
  width: 10px;
  height: 15px;
}
.colorBoxItem3 {
  background-color: rgb(251, 255, 0);
  width: 10px;
  height: 15px;
}
.colorBoxItem4 {
  background-color: rgb(0, 145, 255);
  width: 10px;
  height: 15px;
}
.CheckBoxItem {
  width: 40px;
  display: flex;
  justify-content: center;
  /* background-color: red; */
}
.areaChooseBox {
  height: 50vh;
  width: 100vw;
  background-color: white;
  padding: 20px;
  /* overflow: auto; */
}
.areaChooseTopBox {
  height: 30px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  color: rgb(150, 151, 153);
}
</style>